import { BareButton } from '@calendly/ui/components/bare-button';
import { Icon } from '@calendly/ui/components/icon';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useAdvancedSortable } from 'components/core/sortable';
import AddIconComponent from 'images/icons/interface-add-circle.svg';
import CloseIconComponent from 'images/icons/interface-delete-circle.svg';
const headerCss = "hyu8kau";
export const Header = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'header';
  return <Component ref={ref} {...restProps} className={classNames(headerCss, props.className)} />;
});
const dragHandlerDisabledStateCss = "d1s7o8nh";
const dragHandlerCss = "d1cndwsq";
export const DragHandler = forwardRef((props, ref) => {
  const disabledState = props.disabled;
  return <BareButton ref={ref} {...props} className={classNames(dragHandlerCss, {
    [dragHandlerDisabledStateCss]: disabledState
  }, props.className)}>
      <Icon name="move" />
    </BareButton>;
});
const dragContainerIsDraggingCss = "d1lrogmk";
const dragContainerCss = "dijn6wr";
const DragContainer = forwardRef((props, ref) => {
  const {
    isDragging,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(dragContainerCss, {
    [dragContainerIsDraggingCss]: isDragging
  }, props.className)} />;
});
export const SortableItemWrapper = ({
  id,
  disabled = false,
  DragHandlerComponent = DragHandler,
  children,
  ...props
}) => {
  const {
    sortable: {
      isDragging,
      attributes,
      listeners,
      setNodeRef
    },
    itemStyle
  } = useAdvancedSortable({
    id
  });
  return <DragContainer ref={setNodeRef} isDragging={isDragging} {...props} {...itemStyle}>
      <DragHandlerComponent {...attributes} {...listeners} disabled={disabled} />
      {children}
    </DragContainer>;
};
const addIconCss = "a11xlpu1";
export const AddIcon = forwardRef((props, ref) => <AddIconComponent ref={ref} {...props} aria-hidden className={classNames(addIconCss, props.className)} />);
const closeIconCss = "c15zmiyq";
export const CloseIcon = forwardRef((props, ref) => <CloseIconComponent ref={ref} {...props} className={classNames(closeIconCss, props.className)} />);
const buttonsContainerIsPhoneCss = "bcq6og4";
const buttonsContainerCss = "b1ad2d8d";
export const ButtonsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  return <Component ref={ref} {...restProps} className={classNames(buttonsContainerCss, {
    [buttonsContainerIsPhoneCss]: isPhone
  }, props.className)} />;
});

require("./elements.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./elements.js");